import React, { useState, useEffect, ReactPropTypes } from "react";
import { Drawer, Input, Form } from 'antd';
import { MenuOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from 'react-router-dom';
import { constantConfig } from 'web-common';
import { generateMenuList, updateIsMobile } from '../../store/action';
import { HeaderDrawerCloseIcon, HeaderDrawerSearchIcon, HeaderLogoIcon } from '../../component/icon/Icon';
import { generateClassName, ObjTest } from "../../util/common";
import { HEADER_H } from '../../config/constant';
import useWindowResize from '../../hooks/useWindowResize';
import { MenuItemVo } from '../../config/menus';

import './style/header.less';


const { WEBSITE_PATHS } = constantConfig;



const { Search } = Input;
// 折叠导航项的高度
const NAV_HEIGHT = 50;
// Logo
// const header_logo = require('../../assets/images/logo-white.png');


/**
 * 头部组件
 * @param props
 * @constructor
 */
const Header = (props: any) => {

	const { menus } = useSelector((state: any) => state.reducer);
	const history = useHistory();
	const dispatch = useDispatch();
	// 是否开启半透明
	const [isTransparent, setIsTransparent] = useState<boolean>(false); 
	// 导航抽屉开关
	const [menuVisible, setMenuVisible] = useState<boolean>(false); 
	// 抽屉搜索开关
	const [showSearch, setShowSearch] = useState<boolean>(false); 
	// 搜索值
	const [searchValue, setSearchValue] = useState<string>(null);
	// 主导航激活的下标
	const [activeMainIndex, setActiveMainIndex] = useState<number>(null);
	// 二级导航激活的下标
	const [activeSecondIndex, setActiveSecondIndex] = useState<number>(null);
	const [searchForm] = Form.useForm();


	// 滚动吸顶
	useEffect(() => {

		dispatch(generateMenuList());

		let handler = (e: any) => {
			setIsTransparent(window.scrollY > HEADER_H);
		}
		window.addEventListener('scroll', handler, false);
		return () => {
			window.removeEventListener('scroll', handler, false);
		}
	}, []);


	// 窗口大小变化
	useWindowResize((bodyRect) => {
		const { width } = bodyRect || {};
		dispatch(updateIsMobile(width));
	});

	
	/**
	 * 搜索事件
	 */
	const onSearch = () => {
		setShowSearch(false);
		searchValue && history.replace(`${WEBSITE_PATHS.search}?value=${searchValue}`);
	};


	/**
	 * 自定义抽屉头部
	 */
	const customDrawerHeader = () => {
		return (
			<div className="header-drawer-custom-title flexic flexjs" style={{height: HEADER_H}}>
				<div className="flex1">
					<div 
						className={generateClassName([
							"flexic search-region",
							showSearch ? "active" : null
						])}
						style={{
							// 搜索功能暂时不做，隐藏
							display: 'none'
						}}
					>
						<div className="flex1">
							{
								showSearch ? (
									<Input placeholder="请输入搜索关键字" value={searchValue} onChange={(e) => setSearchValue(e.currentTarget.value)} />
								) : (
									<div className="w h22" title="占位" />
								)
							}
						</div>
						{
							showSearch ? (
								<span className="w50 flexic flexjc mr1 crp search-btn" onClick={onSearch}>搜索</span>
							) : (
								<HeaderDrawerSearchIcon className="drawer-search-icon crp" onClick={() => setShowSearch(true)} />
							)
						}
					</div>
				</div>
				<div className="w30 tr">
					<HeaderDrawerCloseIcon className="drawer-close-icon f20" onClick={() => setMenuVisible(false)} />
				</div>
			</div>
		);
	};


	return (
		<div 
			className={generateClassName([
				"company-header-wrapper flexic flexjs w",
				isTransparent ? "header-transparent" : null
			])}
			style={{height: HEADER_H}}
		>	

			{/* 左侧 - LOGO */}
			<div className="header-logo">
				{/* <a className="flexic" href="/"><img src={header_logo} loading="lazy" alt="基准方中" /></a> */}
				<a className="flexic" href="/"><HeaderLogoIcon className="f120" title="基准方中" /></a>
			</div>

			{/* 右侧 - 导航控制 */}
			<div className="header-menu">
				<MenuOutlined className="header-menu-icon f20" onClick={() => setMenuVisible(true)} />
			</div>

			{/* 抽屉式导航 */}
			<Drawer
				className="header-drawer-wrapper"
				placement="right"
				keyboard={false} // 键盘关闭 
				closable={false}
				title={customDrawerHeader()}
				open={menuVisible}
				width={320}
				onClose={() => setMenuVisible(false)} 
			>
				<div className="flex pr header-nav">
					{/* 主导航 */}
					<div className="main-nav w">
						<ul>
							{menus.map((v: MenuItemVo, index: number) => (
								<li 
									key={v.menuName}
									style={{height: NAV_HEIGHT}}
									className={generateClassName(["flexic mb24 pr", activeMainIndex === index ? "active" : null])}
									
								>
									<div 
										className="main-item"
										onMouseEnter={(e) => {
											// 鼠标移入时，显示二级导航
											setActiveMainIndex(index);
											// 二级导航下标清空
											setActiveSecondIndex(null);
										}}
										onClick={() => {
											if (!v.children || !ObjTest.isNotEmptyArray(v.children)) {
												// 没有二级导航时，关闭侧滑导航
												setMenuVisible(false);
											}
											
											if (v.path) {
												// 外部跳转
												if (v.isOutLink) {
													window.open(v.path, '_blank');
												}
												// 内部跳转
												if (!v.isOutLink) {
													history.replace(v.path);
												}
											}
										}}
									>
										<div className="f18">{v.menuName}</div>
										<div className="f14">{v.englishName}</div>
									</div>
									{
										// 二级导航
										activeMainIndex === index ? (
											<div className="pa second-nav">
												{(v.children || []).map((item: MenuItemVo, index: number) => (
													<div 
														key={item.menuName} 
														className={generateClassName(["flexic pl16 h40 second-item", activeSecondIndex === index ? "active" : null])}
													>
														<span 
															className="f18"
															onClick={() => {
																setActiveSecondIndex(index);
																setMenuVisible(false);
																let tempPath = item.path || v.path;
																if (item.menuId) {
																	// 有动态的menuId
																	tempPath = `${tempPath}?menuId=${item.menuId}`;
																}
																history.replace(tempPath);
															}}
														>
															{item.menuName}
														</span>
													</div>
												))}
											</div>
										) : (null)
									}
									
								</li>
							))}
						</ul>
					</div>
				</div>
			</Drawer>
		</div>
	);
}

export default Header;
